import { Badge } from '@reflex/ui/components/ui/badge';
import { cn } from '@reflex/ui/lib/utils';

interface MonoBadgeProps {
  children: React.ReactNode;
  className?: string;
}

export function MonoBadge({ children, className }: MonoBadgeProps) {
  return (
    <Badge variant="secondary" className={cn('font-mono text-2xs font-normal', className)}>
      {children}
    </Badge>
  );
}
